import React, { useEffect } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import Iconbox from "../../src/assets/Group 5.png";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import initializeAOS from "../utils/aosLibrary";
import line_vector from "../assets/line3-vector.svg";
import arrow_new from "../assets/Arrow_service.svg";
import { useMediaQuery } from "@mui/material";

function TermsConditions() {
  const isXs = useMediaQuery("(min-width:600px) and (max-width:3000px)");
  const fontLivic = "Livvic , sans-serif";
  useEffect(() => {
    document.title = "Terms and Conditions – User Agreement and Policies";
    let metaDescription = document.querySelector("meta[name='description']");
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content",
      "Review the Terms and Conditions outlining our policies and guidelines to ensure a secure and transparent experience for all users."
    );
    initializeAOS();
  }, []);

  return (
    <>
      <Navbar />
      <div
        style={{
          height: "300px",
          background:
            "linear-gradient(105deg, rgba(244, 236, 194, .6) 1.74%, rgba(228, 250, 242, .6) 39.85%, rgba(211, 243, 207, .6) 73.94%, rgba(255, 243, 228, .6) 98.01%)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div>
          <h1
            data-aos="fade-up"
            style={{
              fontSize: isXs ?"64px":"50px",
              lineHeight: "1.15",
              letterSpacing: "0.67px",
              fontWeight: "bold",
              fontWeight: "700",
              textAlign: isXs ? "" : "center",
            }}
          >
            Terms & Conditions
          </h1>
        </div>
        <div
          data-aos="fade-up"
          data-aos-duration="3000"
          style={{
            color: "black",
            fontFamily: fontLivic,
            fontSize: "18px",
            textAlign: "center",
          }}
        ></div>
        <img
          src={arrow_new}
          loading="lazy"
          alt="Hero Shape Image"
          className="hero-shape-2"
          style={{
            display: isXs ? "flex" : "none",
            animation: "moveUpDown 1.5s infinite alternate",
            position: "absolute",
            top: "180px",
            left: "87px",
            zIndex: "5",
          }}
        />
        <img
          style={{
            position: "absolute",
            right: "0",
            top: "200px",
            display: isXs ? "flex" : "none",
          }}
          src={line_vector}
          alt=""
        />
      </div>

      <div style={{ padding: isXs ? "90px 150px" : "90px 30px" }}>
        <div
          style={{
            fontSize: isXs ? "48px" : "40px",
            fontWeight: "600",
            margin: "20px 0px",
          }}
        >
          Fundnest IT Services Agreement
        </div>

        <div
          style={{ fontSize: "24px", fontWeight: "600", margin: "24px 0px" }}
        >
          1. Scope of Work
        </div>

        <ul style={{ paddingLeft: "45px" }}>
          <li
            style={{
              fontSize: "18px",
              fontFamily: fontLivic,
              letterSpacing: "0.67",
              color: "#4A4A4A",
            }}
          >
            IT Staffing{" "}
          </li>
          <li
            style={{
              fontSize: "18px",
              fontFamily: fontLivic,
              letterSpacing: "0.67",
              color: "#4A4A4A",
            }}
          >
            Strategic Consulting{" "}
          </li>
          <li
            style={{
              fontSize: "18px",
              fontFamily: fontLivic,
              letterSpacing: "0.67",
              color: "#4A4A4A",
            }}
          >
            Design & Development{" "}
          </li>
          <li
            style={{
              fontSize: "18px",
              fontFamily: fontLivic,
              letterSpacing: "0.67",
              color: "#4A4A4A",
            }}
          >
            Digital Marketing{" "}
          </li>
          <li
            style={{
              fontSize: "18px",
              fontFamily: fontLivic,
              letterSpacing: "0.67",
              color: "#4A4A4A",
            }}
          >
            Cloud Solutions{" "}
          </li>
          <li
            style={{
              fontSize: "18px",
              fontFamily: fontLivic,
              letterSpacing: "0.67",
              color: "#4A4A4A",
            }}
          >
            Database Security{" "}
          </li>
        </ul>

        <div
          style={{ fontSize: "24px", fontWeight: "600", margin: "24px 0px" }}
        >
          2.Timeline and Milestones
        </div>
        <ul style={{ paddingLeft: "45px" }}>
          <li
            style={{
              fontSize: "18px",
              fontFamily: fontLivic,
              letterSpacing: "0.67",
              color: "#4A4A4A",
            }}
          >
            The project shall commence on the agreed-upon start date and will be
            completed as per the defined deadlines.{" "}
          </li>
          <li
            style={{
              fontSize: "18px",
              fontFamily: fontLivic,
              letterSpacing: "0.67",
              color: "#4A4A4A",
            }}
          >
            Milestones and deliverables will be outlined in the project plan
            shared with the client.{" "}
          </li>
        </ul>

        <div
          style={{ fontSize: "24px", fontWeight: "600", margin: "24px  0px" }}
        >
          3. Payment Terms{" "}
        </div>
        <ul style={{ paddingLeft: "45px" }}>
          <li
            style={{
              fontSize: "18px",
              fontFamily: fontLivic,
              letterSpacing: "0.67",
              color: "#4A4A4A",
            }}
          >
            Invoices will be issued on a weekly or monthly basis, as specified
            in the agreement.{" "}
          </li>
          <li
            style={{
              fontSize: "18px",
              fontFamily: fontLivic,
              letterSpacing: "0.67",
              color: "#4A4A4A",
            }}
          >
            Payment is due within 10 days of receiving the invoice.{" "}
          </li>
          <li
            style={{
              fontSize: "18px",
              fontFamily: fontLivic,
              letterSpacing: "0.67",
              color: "#4A4A4A",
            }}
          >
            Late payments may result in service delays but will not incur
            additional fees.{" "}
          </li>
        </ul>

        <div
          style={{ fontSize: "24px", fontWeight: "600", margin: "24px 0px" }}
        >
          4. Intellectual Property Rights{" "}
        </div>
        <ul style={{ paddingLeft: "45px" }}>
          <li
            style={{
              fontSize: "18px",
              fontFamily: fontLivic,
              letterSpacing: "0.67",
              color: "#4A4A4A",
            }}
          >
            All intellectual property developed during the project will be the
            exclusive property of Fundnest.{" "}
          </li>
          <li
            style={{
              fontSize: "18px",
              fontFamily: fontLivic,
              letterSpacing: "0.67",
              color: "#4A4A4A",
            }}
          >
            The client will receive a non-exclusive, non-transferable license to
            use the deliverables for their intended purposes.{" "}
          </li>
        </ul>

        <div
          style={{ fontSize: "24px", fontWeight: "600", margin: "24px 0px" }}
        >
          5. Confidentiality and Non-Disclosure{" "}
        </div>
        <ul style={{ paddingLeft: "45px" }}>
          <li
            style={{
              fontSize: "18px",
              fontFamily: fontLivic,
              letterSpacing: "0.67",
              color: "#4A4A4A",
            }}
          >
            Both parties agree to maintain the confidentiality of all
            project-related information.{" "}
          </li>
          <li
            style={{
              fontSize: "18px",
              fontFamily: fontLivic,
              letterSpacing: "0.67",
              color: "#4A4A4A",
            }}
          >
            Disclosure of such information to third parties requires prior
            written consent from the other party.{" "}
          </li>
        </ul>

        <div
          style={{ fontSize: "24px", fontWeight: "600", margin: "24px 0px" }}
        >
          6. Data Protection and Privacy{" "}
        </div>
        <ul style={{ paddingLeft: "45px" }}>
          <li
            style={{
              fontSize: "18px",
              fontFamily: fontLivic,
              letterSpacing: "0.67",
              color: "#4A4A4A",
            }}
          >
            Fundnest will manage all personal and sensitive data in accordance
            with applicable data protection laws and regulations.{" "}
          </li>
        </ul>

        <div
          style={{ fontSize: "24px", fontWeight: "600", margin: "24px 0px" }}
        >
          7. Warranties and Guarantees
        </div>
        <ul style={{ paddingLeft: "45px" }}>
          <li
            style={{
              fontSize: "18px",
              fontFamily: fontLivic,
              letterSpacing: "0.67",
              color: "#4A4A4A",
            }}
          >
            Fundnest guarantees professional, high-quality work in accordance
            with industry standards.{" "}
          </li>
          <li
            style={{
              fontSize: "18px",
              fontFamily: fontLivic,
              letterSpacing: "0.67",
              color: "#4A4A4A",
            }}
          >
            Any identified defects will be addressed and corrected promptly.{" "}
          </li>
        </ul>

        <div
          style={{ fontSize: "24px", fontWeight: "600", margin: "24px 0px" }}
        >
          8. Limitation of Liability
        </div>
        <ul style={{ paddingLeft: "45px" }}>
          <li
            style={{
              fontSize: "18px",
              fontFamily: fontLivic,
              letterSpacing: "0.67",
              color: "#4A4A4A",
            }}
          >
            The total liability of Fundnest under this agreement shall not
            exceed the total fees paid by the client or the agreed project
            amount, whichever is lower.
          </li>
        </ul>

        <div
          style={{ fontSize: "24px", fontWeight: "600", margin: "24px 0px" }}
        >
          9. Termination Clause
        </div>
        <ul style={{ paddingLeft: "45px" }}>
          <li
            style={{
              fontSize: "18px",
              fontFamily: fontLivic,
              letterSpacing: "0.67",
              color: "#4A4A4A",
            }}
          >
            Either party may terminate this agreement by providing a 2-day
            written notice.{" "}
          </li>
          <li
            style={{
              fontSize: "18px",
              fontFamily: fontLivic,
              letterSpacing: "0.67",
              color: "#4A4A4A",
            }}
          >
            Upon termination, the client must pay for all services rendered up
            to the termination date.
          </li>
        </ul>

        <div
          style={{ fontSize: "24px", fontWeight: "600", margin: "24px 0px" }}
        >
          10. Dispute Resolution
        </div>
        <ul style={{ paddingLeft: "45px" }}>
          <li
            style={{
              fontSize: "18px",
              fontFamily: fontLivic,
              letterSpacing: "0.67",
              color: "#4A4A4A",
            }}
          >
            Any disputes arising under this agreement will be resolved through
            arbitration in accordance with the rules of an agreed-upon
            arbitration organization.{" "}
          </li>
        </ul>

        <div
          style={{ fontSize: "24px", fontWeight: "600", margin: "24px 0px" }}
        >
          11. Force Majeure
        </div>
        <ul style={{ paddingLeft: "45px" }}>
          <li
            style={{
              fontSize: "18px",
              fontFamily: fontLivic,
              letterSpacing: "0.67",
              color: "#4A4A4A",
            }}
          >
            Neither party shall be held liable for failure or delay in
            performance due to unforeseen circumstances beyond their control,
            such as natural disasters, strikes, or government actions.{" "}
          </li>
        </ul>

        <div
          style={{ fontSize: "24px", fontWeight: "600", margin: "24px 0px" }}
        >
          12. Governing Law
        </div>
        <ul style={{ paddingLeft: "45px" }}>
          <li
            style={{
              fontSize: "18px",
              fontFamily: fontLivic,
              letterSpacing: "0.67",
              color: "#4A4A4A",
            }}
          >
            {" "}
            This agreement shall be governed by and construed in accordance with
            the laws of the applicable jurisdiction.{" "}
          </li>
        </ul>

        <div
          style={{ fontSize: "24px", fontWeight: "600", margin: "24px 0px" }}
        >
          13. Independent Contractor Status
        </div>
        <ul style={{ paddingLeft: "45px" }}>
          <li
            style={{
              fontSize: "18px",
              fontFamily: fontLivic,
              letterSpacing: "0.67",
              color: "#4A4A4A",
            }}
          >
            {" "}
            Fundnest operates as an independent contractor and is not an
            employee, partner, or agent of the client.{" "}
          </li>
        </ul>

        <div
          style={{ fontSize: "24px", fontWeight: "600", margin: "24px 0px" }}
        >
          14. Insurance
        </div>
        <ul style={{ paddingLeft: "45px" }}>
          <li
            style={{
              fontSize: "18px",
              fontFamily: fontLivic,
              letterSpacing: "0.67",
              color: "#4A4A4A",
            }}
          >
            Fundnest will maintain professional liability insurance with a
            minimum coverage of [Coverage Amount] during the term of this
            agreement.{" "}
          </li>
        </ul>
      </div>

      <Footer />
    </>
  );
}

export default TermsConditions;
